import { useLocation } from "react-router-dom";

import facesDef from "assets/images/dashboard/faces.png";
import bots from "assets/images/dashboard/bots.png";

import { COUNT_PERFORMERS_BOTS, getPeopleCount, getPeopleWord } from "utils/helpers";

import "./IntroPerformers.scss";

export default function IntroPerformers({ marketMode = null, shouldShowBreadcrumbs }) {
  const { pathname } = useLocation();
  const marketModeBots = marketMode && marketMode.bots;

  return (
    <div className={`intro-performers ${shouldShowBreadcrumbs ? "other-style" : ""}`}>
        {marketModeBots
          ? <img src={bots} alt="Исполнители-боты" className="intro-performers__bots-img" />
          : <img src={facesDef} alt="Исполнители-люди" className="intro-performers__people-img" />
        }

        {marketModeBots
          ? <div className="intro-performers__bots-description">
              <p className="intro-performers__bots-description-title">{COUNT_PERFORMERS_BOTS.toLocaleString()} <span>ботов</span></p>
              <p className="intro-performers__bots-description-text">в вашем распоряжении</p>
            </div>
          : <div className="intro-performers__people-description">
              <p className="intro-performers__people-description-title">+ {getPeopleCount(pathname).toLocaleString()}{" "} <span>{`${getPeopleWord(pathname, 'prepositional')}й`}</span></p>
              <p className="intro-performers__people-description-text">и ни одного бота</p>
            </div>
        }        
    </div>
  );
}
